import SuperFetchV2 from '../../superFetchV2';

export type ImageUploadResultDto = {
  imageUrl: string;
  width: number;
  height: number;
};

export const AppApiV2 = {
  uploadsSquareImage: (file: File): Promise<ImageUploadResultDto> => {
    const formData = new FormData();
    formData.append('file', file);
    return SuperFetchV2.post('/uploads/square-images', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
  uploadsRectangleImage: (file: File): Promise<ImageUploadResultDto> => {
    const formData = new FormData();
    formData.append('file', file);
    return SuperFetchV2.post('/uploads/rectangle-images', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
};
